const I = () => (
  <span className="relative inline-block">
    ı
    <span className="absolute left-1/2 top-[0.02em] h-[0.26em] w-[0.26em] -translate-x-1/2 rounded-full bg-[#FDC405]" aria-hidden="true" />
  </span>
);

// Code-drawn version of the uploaded logo artwork (navy badge, white "mirai", yellow dots, "EDUCATIONS" as in the artwork).
export const Logo = ({ size = "md", testId = "header-logo" }) => {
  const s = size === "lg" ? "px-5 py-2.5 text-[2.6rem]" : "px-3.5 py-1.5 text-[1.9rem]";
  return (
    <span data-testid={testId} role="img" aria-label="Mirai Educations"
      className={`inline-flex flex-col items-center rounded-xl bg-[#022857] leading-none ${s}`}>
      <span aria-hidden="true" className="font-display font-extrabold lowercase tracking-[-0.03em] text-white" style={{ lineHeight: 1 }}>
        m<I />ra<I />
      </span>
      <span aria-hidden="true" className="mt-[0.08em] font-display text-[0.36em] font-extrabold uppercase tracking-[0.04em] text-[#FDC405]">
        Educations
      </span>
    </span>
  );
};
